<template>
  <div>
    <div
      class="flex h-full fixed top-0 left-0 pointer-events-none outline-none w-full"
      :class="[isFullscreen, { 'pointer-events-auto': active }]"
      :style="{ zIndex: zIndexContent }"
      @mousedown="mouseDownActive"
      ref="modalContent"
    >
      <transition name="modal-animate" appear @after-enter="$emit('shown')">
        <div
          v-if="active"
          class="zt-modal bg-white w-full relative lg:w-auto"
          :class="{ 'm-4': !fullscreen, 'rounded-zt-default': !fullscreen }"
          :style="{ width }"
        >
          <button
            v-if="showButtonClose && !persistent"
            class="focus:outline-none zt-modal-button-close p-1 flex items-center justify-center absolute cursor-pointer rounded-full"
            @click.stop="$emit('close')"
          >
            <zt-icon class="" name="times" v-if="!fullscreen" />
            <zt-icon class="" name="angle-left" v-else />
          </button>
          <div
            v-if="hasHeader"
            class="zt-modal-header"
            :class="{ 'rounded-t': !fullscreen }"
          >
            <slot name="modal-header">
              <div
                class="flex items-start px-8 py-3"
                :class="{ 'justify-center': fullscreen }"
                v-if="title"
              >
                <h5>{{ title }}</h5>
              </div>
            </slot>
          </div>
          <div class="zt-modal-body rounded-b overflow-hidden">
            <slot />
          </div>
          <slot name="modal-footer" />
        </div>
      </transition>
    </div>
    <zt-overlay :z-index="zIndex" :active="active" />
  </div>
</template>

<script>
export default {
  name: 'ztModal',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    showButtonClose: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: String,
      default: '500px'
    },
    zIndex: {
      type: Number,
      default: 20
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    document.addEventListener('keydown', this.escapeHandler)
  },
  computed: {
    zIndexContent() {
      return this.zIndex + 1
    },
    isFullscreen() {
      if (this.fullscreen) {
        return 'zt-modal-fullscreen-mode items-top'
      }
      return 'items-center justify-center'
    },
    width() {
      if (this.fullscreen) {
        return '100%'
      }
      return this.maxWidth
    },
    hasHeader() {
      return !(!this.title && !this.$slots['modal-header'])
    }
  },
  watch: {
    active: function() {
      document.body.style.overflow =
        this.active && this.fullscreen ? 'hidden' : ''
    }
  },
  methods: {
    mouseDownActive(event) {
      if (this.$refs.modalContent === event.target && !this.persistent) {
        this.$emit('close')
        event.preventDefault()
      }
    },
    escapeHandler(e) {
      if (e.key === 'Escape' && this.active && !this.persistent) {
        this.$emit('close')
      }
    }
  },
  destroyed() {
    document.removeEventListener('keydown', this.escapeHandler)
  }
}
</script>

<style
  scoped
  lang="css"
  src="../../../../../src/styles/components/ztModal.css"
></style>
